export const FETCH_ACCESS_FAILURE = 'FETCH_ACCESS_FAILURE';
export const FETCH_ACCESS_LOADING = 'FETCH_ACCESS_LOADING';
export const FETCH_ACCESS_SUCCESS = 'FETCH_ACCESS_SUCCESS';

export const ADD_ACCESS_SUCCESS = 'ADD_ACCESS_SUCCESS';
export const ADD_ACCESS_FAILURE = 'ADD_ACCESS_FAILURE';
export const ADD_ACCESS_LOADING = 'ADD_ACCESS_LOADING';

export const UPDATE_ACCESS_SUCCESS = 'UPDATE_ACCESS_SUCCESS';
export const UPDATE_ACCESS_FAILURE = 'UPDATE_ACCESS_FAILURE';
export const UPDATE_ACCESS_LOADING = 'UPDATE_ACCESS_LOADING';

export const DELETE_ACCESS_SUCCESS = 'DELETE_ACCESS_SUCCESS';
export const DELETE_ACCESS_FAILURE = 'DELETE_ACCESS_FAILURE';
export const DELETE_ACCESS_LOADING = 'DELETE_ACCESS_LOADING';


export const UPDATE_GROUP_ACCESS_LOADING = "UPDATE_GROUP_ACCESS_LOADING";
export const UPDATE_GROUP_ACCESS_SUCCESS = "UPDATE_GROUP_ACCESS_SUCCESS";
export const UPDATE_GROUP_ACCESS_FAILURE = "UPDATE_GROUP_ACCESS_FAILURE";

export const FETCH_GROUP_ACCESS_LOADING = "FETCH_GROUP_ACCESS_LOADING";
export const FETCH_GROUP_ACCESS_SUCCESS = "FETCH_GROUP_ACCESS_SUCCESS";
export const FETCH_GROUP_ACCESS_FAILURE = "FETCH_GROUP_ACCESS_FAILURE";


export const FETCH_ZONE_PRIORITIES_WITH_USERS_LOADING = 'FETCH_ZONE_PRIORITIES_WITH_USERS_LOADING';
export const FETCH_ZONE_PRIORITIES_WITH_USERS_SUCCESS = 'FETCH_ZONE_PRIORITIES_WITH_USERS_SUCCESS';
export const FETCH_ZONE_PRIORITIES_WITH_USERS_FAILURE = 'FETCH_ZONE_PRIORITIES_WITH_USERS_FAILURE';

export const DELETE_INDIVIDUAL_ACCESS_LOADING = 'DELETE_INDIVIDUAL_ACCESS_LOADING';
export const DELETE_INDIVIDUAL_ACCESS_SUCCESS = 'DELETE_INDIVIDUAL_ACCESS_SUCCESS';
export const DELETE_INDIVIDUAL_ACCESS_FAILURE = 'DELETE_INDIVIDUAL_ACCESS_FAILURE';

